import type { ReactNode } from 'react';

export interface BidiTextProps {
  children: ReactNode;
  dir?: 'ltr' | 'rtl' | 'auto';
}

// Wraps content in <bdi> so the parent paragraph's bidi algorithm cannot
// reorder embedded numbers, latin chars, or punctuation around it.
export function BidiText({ children, dir = 'auto' }: BidiTextProps) {
  return <bdi dir={dir}>{children}</bdi>;
}

export interface MonoCodeProps {
  children: ReactNode;
}

export function MonoCode({ children }: MonoCodeProps) {
  return (
    <code dir="ltr" style={{ unicodeBidi: 'isolate', fontFamily: 'ui-monospace, monospace' }}>
      {children}
    </code>
  );
}

export interface FormatDateBidiOpts {
  locale?: string;
  calendar?: 'gregorian';
}

export function formatDateBidi(d: Date | string, opts?: FormatDateBidiOpts) {
  const date = typeof d === 'string' ? new Date(d) : d;
  const locale = opts?.locale ?? 'en-GB';
  const text = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
  return <BidiText dir="ltr">{text}</BidiText>;
}
